export default "__VITE_ASSET__TBOmlrbQ__"